import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { FlightService } from 'src/app/services/flight.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { UserService } from 'src/app/services/user.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TripService } from 'src/app/services/trip.service';
import {BreakpointObserver} from '@angular/cdk/layout';
import {StepperOrientation, MatStepperModule, MatStepper} from '@angular/material/stepper';
import { HotelService } from 'src/app/services/hotel.service';
import {SettingsService} from '../../services/settings.service';
import { HotelCityService } from 'src/app/services/hotel-city.service';
import {HotelManagementService}  from 'src/app/services/hotel-management.service'
import { DropDownInput } from 'src/app/util/drop-down/drop-down.component';

@Component({
  selector: 'app-hotel-manual-cart',
  templateUrl: './hotel-manual-cart.component.html',
  styleUrls: ['./hotel-manual-cart.component.css']
})
export class HotelManualCartComponent {
  bookingForm: FormGroup;
  pending:boolean=false
  pendingINT:boolean=false
  domList:any=[]
  intList:any=[]
  type:any='D'
  hotelCityList:any=[]
  minData=new Date()
  checkIn:any=new Date()
  checkOut:any=this.date1Plus(new Date())
  firstFormGroup:any = this._formBuilder.group({
    cityData: [{city:'',country:''}, Validators.required],
    checkIn: ['', Validators.required],
    checkOut: ['', Validators.required],
    checkInTime: ['12:00 PM'],
    checkOutTime: ['12:00 PM'],
    source:['', Validators.required],
    supplier:['', Validators.required],
    cityRequired:['', Validators.required]
  });
  secondFormGroup = this._formBuilder.group({
    hotelName: ['', Validators.required],
    star: ['', Validators.required],
    address:['', Validators.required],
    pinCode:[''],
    mmtAmenities:[[]],
    description:[''],
    contactNumber: ['', [Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    contactEmail: ['', [Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    roomType:['', Validators.required],
    mealType:['', Validators.required],
    inclusions:[''],
    bookingId:['', [Validators.required,Validators.pattern('^[a-zA-Z0-9]*$')]],

    checkBookingId:['', Validators.required],

  });
  thirdFormGroup = this._formBuilder.group({
    baseFare: ['', Validators.required],
    taxes: ['', Validators.required],
    bookingPaymentType:['R', Validators.required]
  });
  stepperOrientation: Observable<StepperOrientation>;

//   constructor(private _formBuilder: FormBuilder, breakpointObserver: BreakpointObserver) {
   
//   }

@ViewChild('stepper') private myStepper!: MatStepper;

  constructor(private HotelService:HotelService,private fb: FormBuilder,private _formBuilder: FormBuilder, breakpointObserver: BreakpointObserver, private  SettingsService:SettingsService,private toastMsgService : ToastmsgService, private CityService: HotelCityService,private HotelManagementService:HotelManagementService,private ChangeDetectorRef:ChangeDetectorRef) {
  this.getSourcelist()
    // this.getHotelCityList();
    // this.CityService.loadPopularCities();
    // this.CityService.loadOtherCities();
    this.stepperOrientation = breakpointObserver
    .observe('(min-width: 800px)')
    .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));

    this.bookingForm = this.fb.group({
      bookingType: ['Domestic'],
      packageType: ['Hotel'],
      city: [''],
      otherLocation: [''],
      nationality: ['India'],
      checkIn: [''],
      checkOut: [''],
      paymentType: ['Deposit Prepay'],
      rooms: [1],
      roomType: [''],
      adults: [1],
      children: [0]
    });
    this.onRoomCountChange()
    // this.getHotelDAPIList('D')
    // this.getHotelIAPIList('I')
  }

  getHotelCityList() {
    this.domList = this.CityService.hotelCitiesDomestic[0];
    this.intList=this.CityService.hotelCitiesInternational[0];
    this.pending=!this.CityService.citiesLoad.popularDomesticLoad;
    this.pendingINT=!this.CityService.citiesLoad.popularInternationalLoad;
    if(this.domList){
      if(this.domList!=0){
        this.onDOMINTChange()

      }

    }

    // console.log("international flag on first call == " + this.pendingINT);
    this.CityService.getCityLoadDomesticSub().subscribe({next : (param:any) => {
      this.domList = this.CityService.hotelCitiesDomestic[0];
      this.pending=!this.CityService.citiesLoad.popularDomesticLoad;
      // this.getHotelList("D");
      this.onDOMINTChange()

      // console.log("Domestic - ");
      // console.log(param);
    }});
    this.CityService.getCityLoadInternationalSub().subscribe({next : (param:any) => {
      this.intList=this.CityService.hotelCitiesInternational[0];
      this.pendingINT=!this.CityService.citiesLoad.popularInternationalLoad;
      // console.log("International - ");
      // console.log(param);
      //console.log("international flag on subscription == " + this.pendingINT);
      //this.getHotelIList("I");
    }});
  }

  getRooms(): number[] {
    return Array(this.bookingForm.value.rooms).fill(0);
  }

  submitForm() {
    console.log('Form Data:', this.bookingForm.value);
    alert('Booking Created Successfully!');
  }

  convertTimeZone(input:any){
    const inputDateTime = input;
    const datePipe = new DatePipe('en-IN');
  
    let formattedDateTime:any = datePipe.transform(inputDateTime, 'yyyy-MM-dd');
    return formattedDateTime;
  }
  generateUUIDv4(): string {
    let date:any=new Date().getDate();
    let time:any=new Date().getTime();
    let uuidDate:any=date+time;
    // console.log(date+"t"+time)
    return uuidDate+'-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  showSpinners = true;        // Show spinners for time input
  showSeconds = true;         // Allow seconds input
  stepHour = 1;               // Hour step
  stepMinute = 1;             // Minute step
  stepSecond = 1;             // Second step
  touchUi = false;            // Show in touch UI mode
  color: 'primary' | 'accent' | 'warn' = 'primary'; // Date picker color
  enableMeridian = false;      // 12-hour format (AM/PM)
  disableMinute = false;      // Enable/disable minute input
  hideTime = false;   
  hideDate=true        // Hide time portion of the picker
  disabled = false;  
  mmtAmenities:any= [
    {
        "name": "Basic Facilities",
        "displayName": "Power backup"
    },
    {
        "name": "Basic Facilities",
        "displayName": "Refrigerator"
    },
    {
        "name": "Basic Facilities",
        "displayName": "Housekeeping"
    },
    {
        "name": "Basic Facilities",
        "displayName": "Room service"
    },
    {
        "name": "Basic Facilities",
        "displayName": "Laundry"
    },
    {
        "name": "Basic Facilities",
        "displayName": "Smoke detector"
    },
    {
        "name": "Basic Facilities",
        "displayName": "Wifi"
    },
    {
        "name": "Payment Services",
        "displayName": "Currency Exchange"
    },
    {
        "name": "Safety and Security",
        "displayName": "CCTV"
    },
    {
        "name": "Safety and Security",
        "displayName": "Fire extinguishers"
    },
    {
        "name": "Health and wellness",
        "displayName": "Gym/ Fitness centre"
    },
    {
        "name": "Health and wellness",
        "displayName": "First-aid services"
    },
    {
        "name": "General Services",
        "displayName": "Luggage storage"
    },
    {
        "name": "General Services",
        "displayName": "Luggage assistance"
    },
    {
        "name": "General Services",
        "displayName": "Doctor on call"
    },
    {
        "name": "General Services",
        "displayName": "Caretaker"
    },
    {
        "name": "Common Area",
        "displayName": "Reception"
    },
    {
        "name": "Common Area",
        "displayName": "Seating Area"
    }
]
/* {
                                    "cancelPaneltyDesc": "Free Cancellation (100% refund) if you cancel this booking before 2025-03-22 11:59:59 (destination time). Cancellations post that will be subject to a hotel fee as follows:From 2025-03-22 12:00:00 (destination time) till 2025-03-24 11:59:59 (destination time) - 100% of booking amount.After 2025-03-24 12:00:00 (destination time) - 100% of booking amount.Cancellations are only allowed before CheckIn.",
                                    "penalties": [
                                        {
                                            "startDate": "2025-03-21 11:16:07",
                                            "endDate": "2025-03-22 11:59:59",
                                            "penaltyValue": "0.0",
                                            "penaltyType": "PBA"
                                        },
                                        {
                                            "startDate": "2025-03-22 12:00:00",
                                            "endDate": "2025-03-24 11:59:59",
                                            "penaltyValue": "100.0",
                                            "penaltyType": "PBA"
                                        },
                                        {
                                            "startDate": "2025-03-24 12:00:00",
                                            "endDate": "2025-03-25 23:59:59",
                                            "penaltyValue": "100.0",
                                            "penaltyType": "PBA"
                                        }
                                    ]
                                }*/
                                 // {
                                    //     "code": "CP",
                                    //     "value": "Breakfast"
                                    // }
                                      // {
                    //     "id": "GuestProfile",
                    //     "category": "Guest Profile",
                    //     "policyList": [
                    //         "Groups with only male guests are not allowed at this property",
                    //         "Unmarried couples are not allowed"
                    //     ]
                    // },
                    // {
                    //     "id": "IDProofRelated",
                    //     "category": "ID Proof Related",
                    //     "policyList": [
                    //         "Local ids not allowed",
                    //         "Passport, Driving License, Govt. ID and Aadhar are accepted as ID proof(s)"
                    //     ]
                    // },
                    // {
                    //     "id": "SmokingAlcoholconsumptionRules",
                    //     "category": "Smoking/Alcohol consumption Rules",
                    //     "policyList": [
                    //         "Alcohol consumption is not allowed within the property premises.",
                    //         "Smoking within the premises is not allowed"
                    //     ]
                    // },
                    // {
                    //     "id": "PetsRelated",
                    //     "category": "Pet(s) Related",
                    //     "policyList": [
                    //         "Pets are not allowed",
                    //         "There are no pets living on the property"
                    //     ]
                    // },
                    // {
                    //     "id": "PropertyAccessibility",
                    //     "category": "Property Accessibility",
                    //     "policyList": [
                    //         "This property is not accessible to guests who use a wheelchair. Please make arrangements accordingly."
                    //     ]
                    // },
                    // {
                    //     "id": "OtherRules",
                    //     "category": "Other Rules",
                    //     "policyList": [
                    //         "Does not allow private parties or events",
                    //         "Guests are requested not to invite outside visitors in the room during their stay."
                    //     ]
                    // }









roomCount: number = 1;
roomss: any[] = [];
roomOptions: number[] = [1, 2, 3, 4, 5]; // You can change the number of room options
adultOptions: number[] = [1, 2, 3, 4];
childOptions: number[] = [0,1, 2, 3];
childAgeOptions: number[] = [1, 2, 3,4,5,6,7,8,9,10,11];
adult:any;
  child:any;
  rooms:any;
onRoomCountChange() {
  this.roomss = [];
  for (let i = 0; i < this.roomCount; i++) {

    this.roomss.push({
      adults: 1,
      childrenCount: 0,
      childrenAges: []
    });
  }
  if(this.roomCount>1){
    this.rooms=this.roomCount+` `+"Rooms"
  
  }else{
    this.rooms=this.roomCount+` `+"Room"
  
  }  
  this.adult=this.calculateTotals(this.roomss).totalAdults+` `+"Adult"
  
  this.child=this.calculateTotals(this.roomss).totalChildren+` `+"Child"
}

onAdultChange(){
  this.adult=this.calculateTotals(this.roomss).totalAdults+` `+"Adult"

}
onChildrenCountChange(roomIndex: number) {
  const room = this.roomss[roomIndex];
  // console.log(room.childrenCount)
  room.childrenAges = Array.from({ length: room.childrenCount }, () => 1);
  // console.log(room.childrenAges)
  if(this.roomCount>1){
    this.rooms=this.roomCount+` `+"Rooms"
  
  }else{
    this.rooms=this.roomCount+` `+"Room"
  
  }  
  this.adult=this.calculateTotals(this.roomss).totalAdults+` `+"Adult"
  this.child=this.calculateTotals(this.roomss).totalChildren+` `+"Child"
}

calculateTotals(data: any) {
  let totalAdults = 0;
  let totalChildren = 0;

  data.forEach((item:any) => {
      // Add to total adults
      totalAdults += typeof item.adults === 'string' ? parseInt(item.adults, 10) : item.adults;

      // Add to total children based on the childrenCount
      totalChildren += typeof item.childrenCount === 'string' ? parseInt(item.childrenCount, 10) : item.childrenCount;
  });

  return { totalAdults, totalChildren };
}

getHotelDAPIList(type:any){
  this.HotelService
  .getcityList(type)
  .subscribe({
    next : (res:any) => {

      if(res){
        this.domList=res[0]
        this.onDOMINTChange()
      }
    },error : (err) => {

              
          }})}

          getHotelIAPIList(type:any){
            this.pending=true
         
             this.HotelService
             .getcityList(type)
             .subscribe({
               next : (res:any) => {
                 this.pending=false
         
                 if(res){
                   this.intList=res[0]
                   
                 }
               },error : (err) => {
                 this.pending=false
         
                         
                     }})}
                     onDOMINTChange(){
                        
                        if(this.type==='D'){
                            this.hotelCityList=this.domList
                            this.searchQuery=" "
                            this.filterEntities()
                        }else if(this.type==='I'){
                            this.hotelCityList=this.intList
                            this.searchQuery=" "
                            this.filterEntities()

                        }

                     }
                    
                     date1Plus(item:any)
                     {
                       const originalDate = new Date(item);
                       const newDate = new Date(originalDate.setDate(originalDate.getDate() + 1));
                       return newDate
                     } 
                     onDateChange(event: any,item:any) {
                        const selectedDate = event.value; // Get the selected date
                        if (selectedDate) {
                          const formattedDate = this.formatDate(selectedDate);
                          item=formattedDate
                        }
                      }

                      formatDate(date: Date): string {
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
                        const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
                        return `${year}-${month}-${day}`;
                      }
                     searchQuery: any = '';

filteredEntities: any[] = [...this.hotelCityList]; // Clone the original data
cityData:any={}
// Function to filter the entities based on the search query
onChangeCity(){
    this.searchQuery=" "
this.firstFormGroup.value.cityRequired=this.firstFormGroup.value.cityData.city
this.firstFormGroup.setValue(this.firstFormGroup.value);

}
filterEntities() {

  this.filteredEntities = this.hotelCityList.filter((item:any) =>
    item.cityName.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
    
  );

  
}
onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }

  CreateCarts(){

    
    if(this.thirdFormGroup.value.baseFare&&this.thirdFormGroup.value.taxes&&this.thirdFormGroup.value.bookingPaymentType){

   
   let totalAmount=Number(this.thirdFormGroup.value.baseFare||'0')+Number(this.thirdFormGroup.value.taxes||'0')

    let requestId:any=this.generateUUIDv4()
   let request:any={
    "bookingPaymentType":this.thirdFormGroup?.value?.bookingPaymentType,
        "bookingId":this.secondFormGroup?.value?.bookingId,
        "hotelContactNumber":this.secondFormGroup?.value?.contactNumber,
        "hotelContactEmail":this.secondFormGroup?.value?.contactEmail,
        "source":this.firstFormGroup?.value?.source,
        "supplier":this.firstFormGroup?.value?.supplier,
        "hotelRequest": {
            "city": this.firstFormGroup?.value?.cityData?.city,
            
            "checkInDate": this.convertTimeZone(this.firstFormGroup?.value?.checkIn),
            "checkOutDate": this.convertTimeZone(this.firstFormGroup?.value?.checkOut),
            "roomCount": this.roomCount,
            "rooms": this.roomss,
            "rateType": "",
            "country": this.firstFormGroup?.value?.cityData?.country||'IN',
            "requestId":requestId,
            "pageNo": null
        },
        "selectedHotelOrder": {
            "hotel": {
                "hotelId": 28,
                "mmtId": requestId,
                "agodaId": null,
                "expediaId": null,
                "name": this.secondFormGroup?.value?.hotelName,
                "hotelChainName": "",
                "address": this.secondFormGroup?.value?.address,
                "pinCode": this.secondFormGroup?.value?.pinCode,
                "propertyType": "Hotel",
                "childrenAgeFrom": null,
                "childrenAgeTo": null,
                "childrenStayFree": null,
                "infantAge": null,
                "minGuestAge": null,
                "latitude": null,
                "longitude": null,
                "ratings": [
                    {
                        "source": "mmt",
                        "reviewTotalRatingCount": null,
                        "reviewRating":null,
                        "starRating": this.secondFormGroup?.value?.star,
                        "popularityScore": null
                    }
                ],
                "singleRoomProperty": null,
                "checkIn": this.firstFormGroup?.value?.checkInTime||'',
                "checkInInstruction": null,
                "checkInSpecialInstruction": null,
                "checkOut": this.firstFormGroup?.value?.checkOutTime||'',
                "description": this.secondFormGroup?.value?.description,
                "myBizAssured": false,
                "gstin": null,
                "mmtAmenities":this.secondFormGroup?.value?.mmtAmenities,
                "mmtMedia": [
                   
                ],
                "expediaImages": null,
                "agodaAmenities": null,
                "agodaMedia": null,
                "expediaAmenities": null,
                "mmtRooms": [
                    {
                        "name": this.secondFormGroup?.value?.roomType,
                        "code":null,
                        "metadata": {
                            "code": null,
                            "name": this.secondFormGroup?.value?.roomType,
                            "bedRoomCount": null,
                            "roomSize": null,
                            "beds": [
                                // {
                                //     "type": "1 Double bed or 2 Twin Bed(s)",
                                //     "count": 1
                                // }
                            ],
                            "maxGuestCount": null,
                            "maxChildrenCount": null
                        },
                        "media": [],
                        "ratePlans": [
                            {
                                "code": null,
                                "description": this.secondFormGroup?.value?.mealType,
                                "rateType": "1126",
                                "rateCheckId": null,
                                "mealPlans": [
                                  {"code": this.secondFormGroup?.value?.mealType,
                                  "value": this.secondFormGroup?.value?.mealType}
                                  
                                ],
                                "inclusions": [this.secondFormGroup?.value?.inclusions],
                                "paymentMode": null,
                                "cancellationPolicy": null,
                                "price": {
                                    "totalRoomCount": this.roomCount,
                                    "basePrice": Number(this.thirdFormGroup.value.baseFare),
                                    "displayPriceType": "PN",
                                    "totalTax": Number(this.thirdFormGroup.value.taxes),
                                    "couponDiscount": 0,
                                    "hotelDiscount": 0,
                                    "applicableCoupons": [],
                                    "taxBreakup": {
                                        "hotelTax": Number(this.thirdFormGroup.value.taxes),
                                        "hotelServiceCharge": 0,
                                        "serviceFee": 0
                                    }
                                },
                                "freeChildAges": [],
                                "vendorCode": null,
                                "commercial": {
                                    "markup": 0,
                                    "markupDesc": [
                                        // "Fixed Markup 0.0 On Basic",
                                        // "0.0% Markup on Basic"
                                    ],
                                    "charge": 0,
                                    "tax": 0,
                                    "taxDesc": [
                                        // "GST on COMMERCIAL, Rate - 18.0% On COMMERCIAL, GST Amount = 0.0",
                                        // "GST on COMMERCIAL, Rate - 18.0% On COMMERCIAL, GST Amount = 27.0"
                                    ],
                                    "chargeDesc": [
                                        // "ON - BOOKING, Fixed commercial Amount = 150.0",
                                        // "ON - BOOKING, COMMERCIAL PER ROOM NIGHT"
                                    ]
                                },
                                "totalAmount": totalAmount
                            }
                        ],
                        
                    }
                ],
                "agodaRooms": null,
                "expediaRooms": null,
                "mmtPolicies": [],
                "expediaPolicies": null,
                "expediaOnsitePayment": null,
                "slideIndex": 1
            },
            "mmtRequestId": requestId,
            "agodaSearchId": null,
            "expediaSessionId": null
        },
        "requestUuid": requestId
      }
      this.CreateHotelCart(request)}
}
showSpiner:boolean=false
CreateHotelCart(request:any){
    this.showSpiner=true
 
      this.HotelService.generateManualsOrder(request)
      .subscribe({
        next : (res:any) => {
          this.showSpiner=false
  
          if(res) {
           let data:any
           data=res  
           if(data.orderNumber){
    this.newDataPoints()
                this.myStepper.selectedIndex = 0;

           let url= "/app/manual-Booking?id="+this.SettingsService.transform(data.orderNumber)
    window.open(url);
           }else{
            this.toastMsgService.setMsg({msg : "Unable to Create Cart; please try later !",msgTitle:  "Warning", msgType : "W"});
  
           }
          } else {    
            this.toastMsgService.setMsg({msg : "Unable to Create Cart; please try later !",msgTitle:  "Warning", msgType : "W"});
  
          } 
        },error : (err) => {
          this.showSpiner=false
  
          this.toastMsgService.setMsg({msg : "Unable to Create Cart; please try later !",msgTitle:  "Warning", msgType : "W"});
  
        }
      }
    )
    }
    
newDataPoints(){
  this.firstFormGroup = this._formBuilder.group({
    cityData: [{city:'',country:''}, Validators.required],
    checkIn: ['', Validators.required],
    checkOut: ['', Validators.required],
    checkInTime: ['12:00 PM'],
    checkOutTime: ['12:00 PM'],
    source:['', Validators.required],
    supplier:['', Validators.required],
    cityRequired:['', Validators.required]
  });
  this.secondFormGroup = this._formBuilder.group({
    hotelName: ['', Validators.required],
    star: ['', Validators.required],
    address:['', Validators.required],
    pinCode:[''],
    mmtAmenities:[[]],
    description:[''],
    contactNumber: ['', [Validators.pattern("^[\\+]{0,1}[0-9\\s]{10,14}$")]],
    contactEmail: ['', [Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
    roomType:['', Validators.required],
    mealType:['', Validators.required],
    inclusions:[''],
    bookingId:['', [Validators.required,Validators.pattern('^[a-zA-Z0-9]*$')]],

    checkBookingId:['', Validators.required],

  });
  this.thirdFormGroup = this._formBuilder.group({
    baseFare: ['', Validators.required],
    taxes: ['', Validators.required],
    bookingPaymentType:['R', Validators.required]
  });
}
    
    sourceList:any=[]
    getSourcelist(){

      this.HotelManagementService
      .getSourceList()
      .subscribe({
        next : (res:any) => {
          if(res) {
            const data = res
           
  
            this.sourceList=data;
        
          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }
   

    supplierList:any=[]
    getSupplierlist(code:any){

      this.HotelManagementService
      .getSupplierListBySource(code?.value)
      .subscribe({
        next : (res:any) => {
          if(res) {
            const data = res
           
  
            this.supplierList=data;
        
          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }
  





  @ViewChild('addresstextInput', { static: false }) addresstextInput!: ElementRef;

  @Output() setAddress = new EventEmitter<any>();

  addresstextValue: string = '';
  // adressType: string = 'geocode'; // default address type
    adressType: string = '(cities)'; // default address type

  
  pickUpLocation: string = '';
  pickUpLat: any ;
  pickUpLong: any;

  ngAfterViewInit(): void {
    // this.getPlaceAutocomplete();
  }

  public getPlaceAutocomplete() {
    if (this.addresstextInput?.nativeElement && google?.maps?.places) {
      const autocomplete = new google.maps.places.Autocomplete(
        this.addresstextInput.nativeElement,
        {

          types: [this.adressType],
        }
      );

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.invokeEvent(place);
      });
    } else {
      console.error('Autocomplete initialization failed. Element or API not loaded.');
    }
  }
city:any=''
country:any=''
  invokeEvent(place: any) {
    console.log(place)
    const countryComponent = place.address_components?.find(
      (component:any) => component.types.includes('country')
    );
    const addressComponents = place.address_components || [];

    
    const cityComponent = addressComponents.find((component: any) =>
      component.types.includes('locality') || component.types.includes('administrative_area_level_2')||component.types.includes('political')||component.types.includes('administrative_area_level_1')
    );
  
    const isOnlyRegionLevel = addressComponents.some((component: any) =>
      component.types.includes('administrative_area_level_1') || component.types.includes('locality')
    );
  
    
    const cityName = cityComponent?.long_name || place.name || '';


    const countryCode = countryComponent?.short_name;
    const countryName = countryComponent?.long_name;
     if(countryComponent.types.includes('administrative_area_level_1','locality')){

this.pickUpLat = null
this.pickUpLong = null;
     }else{
      this.pickUpLat = place.geometry.location.lat();
      this.pickUpLong = place.geometry.location.lng();
     }
    //  this.city=place?.name
    //  this.country=countryCode

   this.firstFormGroup.value.cityData.city=cityName
   this.firstFormGroup.value.cityData.country=countryCode
   this.firstFormGroup.value.cityRequired=this.firstFormGroup.value.cityData.city
   this.firstFormGroup.setValue(this.firstFormGroup.value);
    this.setAddress.emit(place);
    this.ChangeDetectorRef.detectChanges();

  }


address:any=''
branchFilterParams: DropDownInput={searchFieldName:"formatted_address",keyFieldName : "formatted_address",address:"formatted_address"};

  invokeEventss(itm: any) {
    // console.log(itm)
    this.CityService
    .selectGoogleCity(itm.place_id)
    .subscribe({
      next : (res:any) => {
        if(res) {
          let places=res
          // console.log(data)
          // this.suggestions=data
// console.log(places)
      
    const countryComponent = places?.find(
      (component:any) => component.types.includes('country')
    );
    // console.log(countryComponent)
    const countryCode = countryComponent?.short_name;
    const countryName = countryComponent?.long_name;
    let isCity : boolean=false;
    const cityTypes=['administrative_area_level_1','locality','political','administrative_area_level_2'];     

    for(let i=0;i<cityTypes.length && !isCity;i++) {
      isCity = itm.types?.includes(cityTypes[i]);
    }

     if(isCity){

this.pickUpLat = null
this.pickUpLong = null;
     }else{
      this.pickUpLat = itm.location.latitude;
      this.pickUpLong = itm.location.longitude;
     }
     const addressComponents = places || [];

     const cityComponent = addressComponents.find((component: any) =>
     component.types.includes('locality') || component.types.includes('administrative_area_level_1')||  component.types.includes('administrative_area_level_2')||component.types.includes('political')
   );
 
   const isOnlyRegionLevel = addressComponents.some((component: any) =>
     component.types.includes('administrative_area_level_1') || component.types.includes('locality')
   );

   const cityName = cityComponent?.long_name || itm.name || '';

    //  this.city=cityName
    //  this.country=countryCode

// console.log(this.address)
    // this.fromAirportError = false
   
    // this.departure =itm?.name
    this.addresstextValue=itm?.formatted_address
    this.suggestions = [];
    // this.setAddress.emit(place);
    this.address=itm?.formatted_address
this.firstFormGroup.value.cityData.city=cityName
this.firstFormGroup.value.cityData.country=countryCode
this.firstFormGroup.value.cityRequired=this.firstFormGroup.value.cityData.city
this.firstFormGroup.setValue(this.firstFormGroup.value);
    this.ChangeDetectorRef.detectChanges();
  } else {
        
  } 
},error : (err) => {

}
}
)
  }



  query: string = '';
  suggestions: any[] = [];
  apiKey: string = 'YOUR_GOOGLE_API_KEY'; // 🔐 Replace with your actual key

  searchText="";
  _searchingCity :string='I';
  bookingPaymentType:any
  onInput = async (e : any) => {
    this.searchText=e.text;
    
    if (e.text?.length < 3) {
      this.suggestions = [];
      return;
    }  
    if(this._searchingCity !="I") {
      this._searchingCity="Q";
     
      return;
    }
   this._searchingCity="R";

   const setSearchingCity = () => {
    const _t=this._searchingCity;
        this._searchingCity="I";
        if(_t=="Q") this.onInput({text : this.searchText});
   }
    await this.CityService
    .loadGoogleCity(e.text,null)
    .subscribe({
      next : (res:any) => {
        if(res) {
          let data=res
          const cityTypes = ['administrative_area_level_1', 'locality','administrative_area_level_2','political']; 
          this.suggestions = data.filter((item: any) => 
            item.types.some((type: string) => cityTypes.includes(type))
          );
          console.log(this.suggestions)

// console.log();
        } else {
          this.suggestions=[];
        } 
        setSearchingCity();
      },error : (err) => {
        setSearchingCity();
      }
    }
  )
  }

  checkValidateBookingId(stepper: MatStepper){
   
  let request:any=
    {
     
      "bookingId": this.secondFormGroup?.value?.bookingId,
     
    }

      this.HotelService
      .hotelValidateBookingId(request)
      .subscribe({
        next : (res:any) => {
          if(res) {
            let data=res?.result
            console.log(res)
            if(data?.validationCode==='BIE'){
              this.toastMsgService.setMsg({msg :data?.message,msgTitle:  "Warning", msgType : "W"});

            }else{
              this.secondFormGroup.patchValue({
                checkBookingId: 'check'
              });

              stepper.next(); // Only called if valid

            }
            
            

            // console.log(data)
        //  console.log(this.CreditData)
          } else {
            this.toastMsgService.setMsg({msg :'Failed to process',msgTitle:  "Warning", msgType : "W"});

          } 
        },error : (err) => {
          this.toastMsgService.setMsg({msg :'Failed to process',msgTitle:  "Warning", msgType : "W"});

        }
      }
    )
    
  }
  alphaNumericOnly(event: KeyboardEvent): boolean {
    const charCode = event.key.charCodeAt(0);
  
    // Allow: A-Z, a-z, 0-9
    if (
      (charCode >= 65 && charCode <= 90) ||  // A-Z
      (charCode >= 97 && charCode <= 122) || // a-z
      (charCode >= 48 && charCode <= 57)     // 0-9
    ) {
      return true;
    }
  
    event.preventDefault();
    return false;
  }

  CreateCart(stepper: MatStepper){
   
    let request:any=
      {
       
        "bookingId": this.secondFormGroup?.value?.bookingId,
       
      }
  
        this.HotelService
        .hotelValidateBookingId(request)
        .subscribe({
          next : (res:any) => {
            if(res) {
              let data=res?.result
              if(data?.validationCode==='BIE'){
                this.toastMsgService.setMsg({msg :data?.message,msgTitle:  "Warning", msgType : "W"});
  
              }else{
              
  
                stepper.next(); // Only called if valid
                this.CreateCarts()
  
              }
              
              
  
              // console.log(data)
          //  console.log(this.CreditData)
            } else {
              this.toastMsgService.setMsg({msg :'Failed to process',msgTitle:  "Warning", msgType : "W"});
  
            } 
          },error : (err) => {
            this.toastMsgService.setMsg({msg :'Failed to process',msgTitle:  "Warning", msgType : "W"});
  
          }
        }
      )
      
    }
}
